import styled from 'styled-components';
import GuideBox from '../components/guide/GuideBox';

const PatternGuideList = [
  {
    title: '나만의 AI 경매분석',
    description: `과거 실제 경매 데이터를 기반으로\n나만의 알고리즘을 쉽게 만들고,\n분류 및 저장 기능으로 쉽게 관리해보세요.`,
    subDescription:
      '맞춤 알고리즘으로 경매 물건을 추천 받고 나만의 필승 전략을 찾아보세요.',
    urls: [],
    img: '',
    youtube: 'https://www.youtube.com/embed/2K1QcDpFdxo',
  },
  {
    title: '1. 나만의 알고리즘 만들기',
    description: ``,
    subDescription: '',
    urls: [
      {
        title: '나만의 알고리즘',
        url: '/myAlgorithm',
      },
    ],
    img: '/assets/images/guide/Guide_02_1.png',
  },
  {
    title: '2. AI 기반 실시간 경매 추천',
    description: ``,
    subDescription: '',
    urls: [
      {
        title: 'AI 기반 실시간 경매 추천',
        url: '/AiRecommendation',
      },
    ],
    img: '/assets/images/guide/Guide_02_2.png',
  },
  {
    title: '3. 나만의 알고리즘 보관함',
    description: ``,
    subDescription: '',
    urls: [
      {
        title: '나만의 알고리즘 보관함',
        url: '/myAlgorithmList',
      },
    ],
    img: '/assets/images/guide/Guide_02_3.png',
  },
];

function PatternGuide() {
  return (
    <Box gap={64}>
      {PatternGuideList.map((props, index) => (
        <GuideBox key={index} {...props} />
      ))}
    </Box>
  );
}

export default PatternGuide;

const Box = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;
